<template>
    <BasePanel v-if="can('make-reservations')">
        <template #title>Haal een ticket aan de deur</template>

        <template #default>
            <!-- eslint-disable vue/no-v-html -->
            <p
                v-if="event.doorsaleInformation"
                v-html="event.doorsaleInformation"
            />
            <!-- eslint-enable vue/no-v-html -->
        </template>
    </BasePanel>

    <EventReservationPanelBecomeMember
        v-else
        :event
    />
</template>

<script setup lang="ts">
defineProps<{
    event: EventDate;
}>();

const { can } = useUserStore();
</script>
